var _ellipse, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLogoTextless = function SvgLogoTextless(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 46,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 20.905,
    cy: 19.818,
    rx: 8.097,
    ry: 8.182,
    fill: "#FF616E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.726 31.905a15.381 15.381 0 0 1-12.293 3.342 15.45 15.45 0 0 1-10.612-7.082 19.645 19.645 0 0 1-2.69-8.264 15.395 15.395 0 0 1 .75-6.281A28.36 28.36 0 0 1 8.96 7.773c.636-1.033.79-1.818-.914-1.095a14.71 14.71 0 0 0-5.582 5.837 22.746 22.746 0 0 0-2.289 6.6c-.113.641-1.498 10.331 5.85 16.757a17.793 17.793 0 0 0 4.423 2.675 20.258 20.258 0 0 0 9.154 1.457c2.143-.24 4.227-.86 6.157-1.828.449-.24.884-.506 1.303-.796a16.062 16.062 0 0 0 5.84-7.675 15.7 15.7 0 0 1-2.176 2.2Z",
    fill: "#8FCBE0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.703 11.502a18.542 18.542 0 0 0-5.787-8.843A11.539 11.539 0 0 0 30.92.304c-1.488.403-3.078 1.58-2.883 3.099a4.26 4.26 0 0 0 1.395 2.18c6.18 6.477 8.17 15.925 5.131 24.37a17.55 17.55 0 0 1-6.598 8.79 17.27 17.27 0 0 1-9.893 2.976 22.029 22.029 0 0 1-8.281-1.653 19.243 19.243 0 0 1-4.588-2.727 23.28 23.28 0 0 0 9.667 6.684 24.956 24.956 0 0 0 17.785-.517 25.312 25.312 0 0 0 11.79-10.558c.508-.86.964-1.75 1.366-2.665a26.63 26.63 0 0 0 .892-18.78Z",
    fill: "#3A53A2"
  })));
};
export default SvgLogoTextless;